import { useAuthContext } from './agencyAuthHook'
import { getAgencyVoucherColors } from '../redux/reducers/voucherColorsSlice'
import { useDispatch } from 'react-redux';
import { useState } from 'react';

export default function VoucherColorsHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const[loading,setLoading]=useState(false)
    const { agency } = useAuthContext()
    const getVoucherColors=async()=>{
       try {
        setLoading(true)
        const response=await fetch(`${apiUrl}/api/agencies/voucher_colors/get`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAgencyVoucherColors(json.data))
          setLoading(false)
        }
        
       } catch (error) {
       console.log('error',error)
       setLoading(false)
       }
    }
  return {getVoucherColors,loading}
}
